import styled from 'styled-components';
import colors from './colors';

/* DEFAULT */
export const Container = styled.div`
  max-width: 1170px;
  width: 100%;
  margin: 0 auto;
  padding: 0 30px;

  @media screen and (max-width: 1089px) {
    padding: 0 20px;
  }
`;

export const Wrapper = styled.div`
  max-width: 1170px;
  margin: 0 auto;
  padding: 40px 30px;

  @media screen and (max-width: 1089px) {
    padding: 40px 20px;
  }
`;

export const Breadcrumb = styled.div`
  background: #E9E9E9;
  height: 90px;
  display: flex;
  box-shadow: inset 0px -5px 5px -5px rgba(0,0,0,0.2);

  .container {
    max-width: 1170px;
    width: 79%;
    margin: 0 auto;
    padding: 0 30px;
    display: flex;
    flex: 1;
    align-items: center;

    .breadcrumb {
      display: flex;
      flex: 1;
      align-items: center;
    }
  }

  h2 {
    font-size: 1.25rem;
    font-weight: 300;
    text-transform: uppercase;
    color: #999999;
    white-space: nowrap;
  }

  h2.bold {
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .fa-chevron-right {
    font-size: 1.0rem;
    padding: 2px 12px 0 15px;
    color: #999999;
    opacity: 0.3;
  }

  @media screen and (max-width: 1089px) {
    .container {
      padding: 0 20px;
    }

    h2 {
      font-size: 1.1rem;
    }

    i {
      padding: 1px 15px 0 18px;
    }
  }
`;

export const Row = styled.div`
  @media screen and (min-width: 769px) {
    .row-1 {
      width: 50%;
      display: flex;

      label { margin-right: 15px }
    }

    .row-2 {
      display: flex;

      label {
        margin-right: 15px;

        :last-child {
          margin-left: 15px;
          margin-right: 0;
        }
      }
    }
  }

  @media screen and (min-width: 475px) {
    .row-2-2 {
      display: flex;

      label {
        margin-right: 15px;

        :last-child {
          margin-left: 15px;
          margin-right: 0;
        }
      }
    } 
  }

  @media screen and (max-width: 768px) {
    .opening-hours {
      display: block;

      label {
        margin-right: 0;

        :last-child {
          margin-left: 0;
          margin-right: 0;
        }
      }
    }
  }
`;

export const Label = styled.label`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  p.fieldName {
    font-size: 0.9rem;
    font-weight: 700;
    color: #999;
    letter-spacing: -0.5px;
    padding-bottom: 8px;

    .required {
      color: ${colors.red};
      padding-left: 5px;
    }
  }

  .inputMessage {
    font-size: 0.9rem;
    letter-spacing: -0.5px;
    margin: -5px 0 10px;
  }

  .errorMessage { color: ${colors.red}; }
  .alertMessage { color: #999; }
`;

export const Input = styled.input`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  padding: 10px;
  margin-bottom: 15px;
  background-color: ${colors.white};
  -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  border-radius: 8px;
  border: ${(props) => {
    if (props.error) return `1px solid ${colors.red}`;
    if (props.onFocusInput) return `1px solid ${colors.primary}`;
    return `1px solid ${colors.white}`;
  }};
  outline: none;
`;

export const CurrencyLabel = styled.div`
  display: flex;

  .input {
    flex: 1;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    padding: 10px;
    margin-bottom: 15px;
    background-color: ${colors.white};
    -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    border-radius: 8px;
    border: ${(props) => {
    if (props.error) return `1px solid ${colors.red}`;
    if (props.onFocusInput) return `1px solid ${colors.primary}`;
    return `1px solid ${colors.white}`;
  }};
    outline: none;
  }
`;

export const SelectLabel = styled.div`
  .input__control {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    border: ${props => (props.error ? `1px solid ${colors.red} !important` : `1px solid ${colors.white}`)};
    height: 41px;
    background-color: ${colors.white};
    -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    border-radius: 8px;
    margin-bottom: 15px;
  }

  .input__control:hover { border-color: ${colors.white} }
  .input__control--is-focused { border-color: ${colors.primary} !important }
  .input__placeholder { color: #CCC }
  .input__dropdown-indicator { color: #CCC !important }
  .input__menu { border-radius: 8px }
  .input__menu-list { padding-top: 7px; padding-bottom: 7px }
  .input__option { font-family: 'Open Sans', sans-serif; font-size: 14px }
  .input__option--is-focused { background-color: ${colors.lighter} }
  .input__option:active { background-color: ${colors.lighter} }
  .input__option--is-selected { background-color: ${colors.primary} !important }
`;

export const CheckboxContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  p {
    font-size: 0.9rem;
    font-weight: 700;
    color: #999;
    letter-spacing: -0.5px;
    padding-bottom: 8px;
  }
`;

export const CheckboxLabel = styled.label`
  display: flex;
  margin-right: 30px;
  cursor: pointer;
  
  span {
    font-size: 0.9rem;
    letter-spacing: -0.5px;
    padding-top: 1px;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
`;

export const Textarea = styled.textarea`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  padding: 10px;
  height: 80px;
  margin-bottom: 15px;
  background-color: ${colors.white};
  -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  border-radius: 8px;
  border: ${(props) => {
    if (props.error) return `1px solid ${colors.red}`;
    if (props.onFocusInput) return `1px solid ${colors.primary}`;
    return `1px solid ${colors.white}`;
  }};
  outline: none;
`;

export const Button = styled.button`
  max-width: 160px;
  min-width: 160px;
  margin-top: 20px;
  padding: 15px 0 14px 25px;
  background: ${colors.primary};
  background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
  border: none;
  border-radius: 100px;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${colors.white};
  font-family: 'Open Sans', sans-serif;
  outline: none;
  cursor: pointer;

  :disabled {
    padding: 15px 25px 14px 25px;
  }

  .fa {
    font-size: 1.0rem;
    float: right;
    margin: 1px 20px 0 0;
  }

  :hover { opacity: .9 }

  @media screen and (min-width: 769px) {
    width: 20%;
  }
`;

export const EmptyList = styled.div`
  background-color: ${colors.white};
  border-radius: 8px;
  -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  padding: 20px;

  p {
    font-size: 0.9rem;
    color: #999;
    text-align: center;
  }
`;

export const ScrollTop = styled.button`
  position: fixed;
  right: 30px;
  bottom: 30px;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: ${colors.primary};
  background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
  border: none;
  border-radius: 100px;
  color: ${colors.white};
  outline: none;
  cursor: pointer;

  span {
    font-family: 'Open Sans', sans-serif;
    text-transform: uppercase;
    font-size: 0.9rem;
    font-weight: 600;
  }

  .fa {
    font-size: 0.9rem;
    font-weight: bold;
    padding-right: 5px;
  }

  :hover { opacity: .9 }
`;
